import React, { ReactElement } from 'react';
import { useTranslations } from '../../../../translations';
import { useUser } from '../../../../user';
import { getKCellSupportHref } from '../../customersSubscriptionPopup.helper';
import { IconAttentionComponent } from '../../../../icons';
import {
  CustomersSubscriptionPopup,
  CustomersSubscriptionPopupSubtitle,
  CustomersSubscriptionPopupTitle,
} from '../../customersSubscriptionPopup.styled';

export const CustomerConflict = (): ReactElement => {
  const translations = useTranslations();
  const { user } = useUser();
  return (
    <CustomersSubscriptionPopup>
      <IconAttentionComponent width={48} height={48} fillColor="#201926" />
      <CustomersSubscriptionPopupTitle>
        {translations.subscription_is_activated_for_another_customer.replace(
          '{{PHONE}}',
          user?.personal.phone || ''
        )}
      </CustomersSubscriptionPopupTitle>
      <CustomersSubscriptionPopupSubtitle>
        {translations.login_another_account_or_contact}{' '}
        <a href={getKCellSupportHref()}>{translations.kcell_support}</a>
      </CustomersSubscriptionPopupSubtitle>
    </CustomersSubscriptionPopup>
  );
};
